export default {
    parts: [],
    baseStyle: (props) => ({
        /* General styling */
        container: {
            width: { lg: '100%' },
            maxWidth: { lg: 'container.xxxl' },
            margin: { lg: '0 auto' },
            paddingLeft: { lg: 6 },
            paddingRight: { lg: 6 }
        },
        contentWrapper: {
            paddingLeft: { base: 4, lg: 0 },
            paddingRight: { base: 4, lg: 0 }
        },
        heading: {
            marginTop: 12,
            marginBottom: 12,
            textStyle: 'webH1'
        },
        inputWrapper: {
            paddingBottom: { base: 8, lg: 2 },
        },
        tab: {
            ...(props?.theme?.textStyles?.labelXs || {}),
            padding: { base: '0 0 8px' },
            marginLeft: { base: 4 },
            marginRight: { base: 4 },
            borderBottom: '1px solid',
            borderColor: 'transparent',
            color: 'webTypo.textPrimary',
            _selected: {
                borderColor: 'webTheme.strokeDefault',
                borderBottom: '1px solid',
                mb: '-2px',
                backgroundColor: 'white'
            }
        },
        storesTabPanel: {
            p: {base: '0 16px 16px 16px'},
        },
        mapTabPanel: {
            position: 'relative',
            padding: { base: 0 }
        },
        desktopLayout: {
            display: {lg: 'flex'},
            flexWrap: {lg: 'no-wrap'},
            gap: {lg: 6},
            height: {lg: '670px'},
            marginBottom: {lg: 12}
        },
        mapContainer: {
            flex: {lg: '1'}
        },
        storesContainer: {
            display: {lg: 'flex'},
            flexDirection: {lg: 'column'},
            flex: {lg: '0 0 424px'},
            width: {lg: '100%'},
            maxWidth: {lg: '424px'},
            paddingRight: {lg: '18px'}
        },
        inputAndNoStores: {
            flexShrink: {base: 0}
        },
        storeListWrapper: {
            flex: 1,
            overflow: 'auto'
        },
        dot: {
            display: 'inline-block',
            width: '6px',
            height: '6px',
            marginRight: '5px'
        },
        greenDot: {
            backgroundColor: 'webTheme.supportSuccess'
        },
        redDot: {
            backgroundColor: 'webTheme.supportError'
        },
        hours: {
            display: 'flex',
            alignItems: 'center',
            textStyle: 'bodyXsRegular'
        },
        /* Components */
        components: {
            inputStyling: {
                container: {
                    position: 'relative'
                },
                icon: {
                    position: 'absolute',
                    left: 0,
                    top: '12px',
                },
                inputField: {
                    paddingLeft: {base: 8},
                    paddingRight: {base: 8}
                },
                results: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 6
                },
                stores: {
                    textStyle: 'bodyXsRegular',
                    paddingTop: '10px',
                    textOverflow: {base: 'ellipsis'},
                    whiteSpace: {base: 'nowrap'},
                    overflow: {base: 'hidden'}
                },
                geolocation: {
                    display: 'flex',
                    textStyle: 'bodyXsRegular',
                    alignItems: 'center',
                    flex: {base: '0 0 auto'},
                    marginTop: '10px',
                    cursor: {base: 'pointer'},
                    height: 'unset'
                },
                geoIcon: {
                    marginRight: { base: 1 }
                },
                geoErrorContainer: {
                    flexDirection: 'column',
                    gap: 3,
                },
                geoErrorTitle: {
                    textStyle: 'labelXs'
                },
                geoErrorDescription: {
                    textStyle: 'bodyXsRegular'
                }
            },
            noResults: {
                container: {
                    flexDirection: 'column',
                    gap: 3,
                },
                title: {
                    textStyle: 'labelXs'
                },
                subTitle: {
                    textStyle: 'bodyXsRegular'
                }
            },
            storeCard: {
                container: {
                    position: 'relative',
                    cursor: 'pointer',
                },
                wrapper: {
                    paddingTop: {base: 4, lg: 6},
                    borderBottom: '1px solid',
                    borderBottomColor: 'black'
                },
                cardHeading: {
                    textStyle: 'webH3',
                    display: 'flex',
                    flexWrap: 'no-wrap',
                    alignItems: 'center',
                    marginBottom: {base: 2}
                },
                nameAndDistance: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flex: 1,
                    paddingBottom: { base: 1 }
                },
                name: {
                    textStyle: 'webH3',
                    paddingRight: { base: 4 }
                },
                distance: {
                    textStyle: 'bodyXsRegular',
                    textTransform: 'none',
                    whiteSpace: 'nowrap'
                },
                addressWrapper: {
                    marginBottom: {base: 3}
                },
                address: {
                    textStyle: 'bodySmRegular',
                },
                hoursWrapper: {
                    paddingBottom: {base: 4}
                }
            },
            storeDetails: {
                drawerCloseIcon: {
                    width: {base: '24px'},
                    height: {base: '24px'},
                    minWidth: {base: 'auto'},
                    backgroundColor: 'transparent',
                    color: 'black',
                    display: {base: 'block'},
                    ml: {base: 'auto'},
                    _hover: {
                        backgroundColor: 'transparent'
                    }
                },
                drawerContent: {
                    maxWidth: {lg: '507px'}
                },
                drawerBody: {
                    padding: {base: 4, lg: 6}
                },
                drawerHeader: {
                    boxShadow: {base: 'none'},
                    p: {base: 4, lg: 6},
                    borderBottom: {base: '1px solid'},
                    borderColor: {base: 'webTheme.strokeTertiary'}
                },
                drawerFooter: {
                    display: 'flex',
                    flexWrap: 'no-wrap',
                    gap: 2,
                    p: {base: 4},
                    borderTop: {base: '1px solid'},
                    borderColor: {base: 'webTheme.strokeTertiary'}
                },
                blockSpacing: {
                    marginBottom: {base: 8}
                },
                name: {
                    textStyle: 'webH3',
                    marginBottom: {base: 3}
                },
                address: {
                    textStyle: 'bodySmRegular'
                },
                title: {
                    textStyle: 'webH3',
                    marginBottom: {base: 3}
                },
                cta: {
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    minWidth: 0,
                    px: '8px',
                    py: '10px',
                    height: 'auto',
                    minHeight: '44px',
                    lineHeight: '1.2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    textWrap: 'balance',
                    _hover: {textDecoration: 'none'}
                },
                content: {
                    textStyle: 'bodySmRegular'
                },
                getDirections: {
                    color: 'webTypo.textPrimary',
                },
                statusWrapper: {
                    display: { lg: 'flex' },
                    justifyContent: { lg: 'space-between' },
                    marginTop: { lg: 2 }
                },
            },
            map: {
                desktop: {
                    width: '100%',
                    height: '100%'
                },
                mobile: {
                    width: '100vw',
                    height: '515px'
                }
            }
        }
    })
}
